import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './page-button.scss';

const PageButton = ({ type, onClick, disabled, children, title }) => {
    disabled = disabled ? 'disabled' : 'enabled';
    type = type || 'blue';
    const buttonClass = `btn btn--primary btn--small ${css[disabled]} ${css[type]}`;
    return (
        <button
            className={buttonClass}
            onClick={() => onClick()}
            disabled={disabled === 'disabled'}
            title={title}
        >
            <div className={css['btn-content']}>
                <div>{children}</div>
            </div>
        </button>
    );
};

PageButton.propTypes = {
    type: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.any,
    title: PropTypes.string
};

export default styleable(css)(PageButton);



// WEBPACK FOOTER //
// ./components/page-button/page-button.js